var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._g(
      {
        staticClass: "search-result-ticket",
        class: _vm.classes,
        attrs: {
          "data-bot": _vm.context
            ? "search-result__ticket--" + _vm.context
            : "search-result__ticket",
          href: _vm.link
        },
        on: {
          mouseenter: _vm.handleMouseEnter,
          mouseleave: function($event) {
            _vm.isHovered = false
          }
        }
      },
      _vm.$listeners
    ),
    [
      _c("CompassObject", {
        attrs: { size: "extra-small", type: "object", object: "support-emoji" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "search-result-ticket__content" }, [
        _c("div", { staticClass: "search-result-ticket__title" }, [
          _c("h5", {
            staticClass:
              "search-result-ticket__name typographies-paragraph-medium-bold",
            domProps: { innerHTML: _vm._s(_vm.subject) }
          }),
          _vm._v(" "),
          _vm.status
            ? _c(
                "div",
                { staticClass: "ticket-status" },
                [
                  _c(
                    "CompassTag",
                    {
                      attrs: {
                        size: "small",
                        color: _vm.statusInformation.color,
                        icon: _vm.statusInformation.icon
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.status.label) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "search-result-ticket__third" }, [
          _c("span", {
            staticClass: "typographies-paragraph-medium-regular",
            domProps: { innerHTML: _vm._s(_vm.id) }
          }),
          _vm._v(" "),
          _vm.third !== ""
            ? _c("span", {
                staticClass:
                  "typographies-paragraph-medium-semibold search-result-ticket__company",
                domProps: { innerHTML: _vm._s(_vm.third) }
              })
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }